<div class="col">
	<div class="row gap-4 justify-content-center p-2">
		<div class="col col-auto col-lg-9">
			<div class="row justify-content-center m-2 border-bottom">
				<p class="text-center article-text display-4 m-0">Get in touch</p>
			</div>
			<div class="row align-middle m-2">
				<p class="text-center m-0 article-text fw-bold">Lead Instructor:</p>
				<p class="text-center article-text">Gaige Ehrenworth</p>
				<p class="text-center m-0 article-text fw-bold">Phone:</p>
				<p class="text-center article-text">(501) 607-3799</p>
				<p class="text-center m-0 article-text fw-bold">Email:</p>
				<p class="text-center article-text">gehrenworth&#64;gmail.com</p>
				<p class="text-center article-text m-0 fw-bold">Social Media:</p>
				<app-facebook-banner class="d-flex flex-grow-1" />
			</div>
			<div class="row justify-content-center">
				<img class="bg-transparent img-fluid p-0 col-4" [src]="'wyvern-vertical.svg'" />
			</div>
		</div>
	</div>
</div>